import { AspectRatio } from '@chakra-ui/react';

import { LectureCardUpcomingImagePlaceholder } from '@/components/ui/shared/lecture/LectureCardImage/LectureCardUpcomingImagePlaceholder';

export const LectureSearchCardUpcomingPlaceholder = ({ publishedAt }) => {
  return (
    <AspectRatio maxW="full" ratio={1.69}>
      <LectureCardUpcomingImagePlaceholder publishedAt={publishedAt} />
    </AspectRatio>
  );
};
